import { cn } from '@/utils/cn';
import { Loader2 } from 'lucide-react';

interface LoadingSpinnerProps {
  className?: string;
  fullScreen?: boolean;
  isLoading?: boolean;
}

export const LoadingSpinner = ({ className, fullScreen = false, isLoading = false }: LoadingSpinnerProps) => {
  const spinner = (
    <Loader2 className={cn('animate-spin text-[#0C8DBF] w-[20px] h-[20px] lg:w-[24px] lg:h-[24px]', className)} />
  );

  if (fullScreen || isLoading) {
    return spinner;
  }

  return null;
};
